module.exports = __webpack_public_path__ + "static/pricing_banner-fefeab1efaccacc51ccd49cfaeba72c1.jpg";